import { useCallback } from "react";
import queryString from 'query-string';
import { checkTokenApi, setCookieApi, token2CodeApi } from '../../action';
import useEffectOnce from '../../utils/useEffectOnce';

interface SetCookieParams {
    token?: string;
}

const SetCookie = () => {
    const params: SetCookieParams = queryString.parse(window.location.search.split('?')[1] || '');

    useEffectOnce(() => {
        handleSetCookieApi();
    });

    const handlePostMessage = useCallback((event: string, code: string) => {
        window.parent.postMessage(JSON.stringify({
            from: 'ssoLogin',
            event,
            code
        }), '*');
    }, [])

    // 设置cookie
    const handleSetCookieApi = useCallback(async () => {
        const res = await setCookieApi({
            token: params.token || ''
        });
        if (res.data.code === 0) {
            handlePostMessage('set_cookie_success', '');
        } else {
            handlePostMessage('set_cookie_error', '');
        }
    }, [params]);

    return <div />
};

export default SetCookie;